<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-user bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ this.$t("education.career-detail") }}</h5>
            </div>
          </div>

          <div v-if="loading" class="row mt-4 mx-auto">
            <div class="text-center p-5">
              <div class="spinner-border text-secondary" role="status"></div>
              <p>{{ $t("education.get-data") }} ..</p>
            </div>
          </div>
          <div class="row mt-4" v-if="result.profile_id">
            <div class="col-sm-12">
              <table class="table table-bordered px-2">
                <tbody>
                  <tr>
                    <td width="20%">
                      {{ $t("education.avatar") }}
                    </td>
                    <td>
                      <img
                        :src="result.profile_picture"
                        alt=""
                        class="img-fluid rounded avatar-xl"
                        srcset=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      {{ $t("education.profil_id") }}
                    </td>
                    <td>
                      <a
                        :href="
                          'https://www.linkedin.com/in/' + result.profile_id
                        "
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-primary"
                        >{{ result.profile_id }}</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      {{ $t("education.first_name") }}
                    </td>
                    <td>
                      {{ result.first_name }}
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      {{ $t("education.last_name") }}
                    </td>
                    <td>
                      {{ result.last_name }}
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      {{ $t("education.position") }}
                    </td>
                    <td>
                      <!-- {{result.position_groups}} -->
                      <div
                        v-for="(position, index) in result.position_groups"
                        :key="index"
                        class="border mb-2 p-2"
                      >
                        <span v-if="position.company"
                          ><img
                            :src="position.company.logo"
                            alt=""
                            class="img-fluid rounded avatar-sm mb-1"
                            srcset=""
                            v-if="position.company.logo !== null"
                          />
                          <img
                            src="https://static-exp1.licdn.com/sc/h/3dtfvv2esz58o2zimai1h3v2d"
                            alt=""
                            class="img-fluid rounded avatar-sm mb-1"
                            srcset=""
                            v-else
                          /><br />
                        </span>
                        <span v-if="position.company">
                          <b>{{ $t("education.company") }} : </b
                          >{{ position.company.name }} <br
                        /></span>
                        <span v-if="position.profile_positions"
                          ><b>{{ $t("education.title") }} :</b>
                          {{ position.profile_positions[0].title }} <br />
                        </span>
                        <span v-if="position.profile_positions">
                          <b>{{ $t("education.location") }} : </b>
                          {{ position.profile_positions[0].location }} <br
                        /></span>
                        <div v-if="position.date">
                          <b v-if="position.date.start"
                            >{{ $t("education.start") }} :
                          </b>
                          <span v-if="position.date.start"
                            >{{ position.date.start.year }} -
                            {{ formatMonth(position.date.start.month) }}</span
                          >
                          <br />
                        </div>
                        <div v-if="position.date">
                          <b v-if="position.date.end">
                            {{ $t("education.end") }} :
                          </b>
                          <span v-if="position.date.end"
                            >{{ position.date.end.year }} -
                            {{ formatMonth(position.date.end.month) }} </span
                          ><br />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="result.skills">
                    <td width="20%">
                      {{ $t("education.skills") }}
                    </td>
                    <td>
                      <span
                        v-for="(skills, index) in result.skills"
                        :key="index"
                        class="btn btn-sm btn-light mr-1 mb-1 text-secondary"
                        >{{ skills }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="result.certifications">
                    <td width="20%">
                      {{ $t("education.sertifikat") }}
                    </td>
                    <td>
                      <!-- {{result.certifications}}  -->
                      <div
                        v-for="(skills, index) in result.certifications"
                        :key="index"
                        class="border mb-2 p-2"
                      >
                        <span v-if="skills.company"
                          ><img
                            :src="skills.company.logo"
                            alt=""
                            class="img-fluid rounded avatar-sm mb-1"
                            srcset=""
                          /><br />
                        </span>
                        <span v-if="skills.name"
                          ><b>{{ $t("education.name") }} :</b>
                          {{ skills.name }} <br />
                        </span>
                        <span v-if="skills.date"
                          ><b>{{ $t("education.year") }} : </b>
                          <span v-if="skills.date.start">
                            {{ skills.date.start.year }} -
                            {{ formatMonth(skills.date.start.month) }}</span
                          >
                          <br />
                        </span>
                        <span v-if="skills.license_number">
                          <b>{{ $t("education.licensi-number") }} : </b
                          >{{ skills.license_number }} <br
                        /></span>
                        <span v-if="skills.url"
                          ><b>{{ $t("education.link") }} : </b>
                          <a
                            :href="skills.url"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ skills.url }} </a
                          ><br
                        /></span>
                        <span v-if="skills.display_source"
                          ><b>{{ $t("education.source") }} : </b
                          >{{ skills.display_source }}<br />
                        </span>
                        <span v-if="skills.authority">
                          <b>{{ $t("education.authority") }} : </b
                          >{{ skills.authority }}<br />
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="result.publications.length > 0">
                    <td width="20%">
                      {{ $t("education.publications") }}
                    </td>
                    <td>
                      <div
                        v-for="(publics, index) in result.publications"
                        :key="index"
                        class="border mb-2 p-2"
                      >
                        <span v-if="publics.name"
                          ><b>{{ $t("education.headline") }}: </b>
                          <a
                            :href="publics.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ publics.name }}</a
                          ></span
                        >
                        <br />
                        <span v-if="publics.date"
                          ><b> {{ $t("education.date") }} : </b
                          ><span v-if="publics.date.day">{{
                            publics.date.day
                          }}</span
                          ><span v-if="publics.date.month">
                            {{ formatMonth(publics.date.month) }}</span
                          >
                          {{ publics.date.year }}</span
                        >
                        <br />
                        <span v-if="publics.publisher"
                          ><b> {{ $t("education.publiser") }} : </b
                          >{{ publics.publisher }}</span
                        >
                        <br />
                        <span v-if="publics.authors"
                          ><b> {{ $t("education.authors") }} : </b
                          ><span
                            v-for="(ath, index) in publics.authors"
                            :key="index"
                            >({{ ath.first_name }} {{ ath.last_name }},
                            {{ ath.headline }}, {{ ath.type }}),
                          </span></span
                        >
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%">
                      {{ $t("education.target-profil") }}
                    </td>
                    <td>
                      <div class="form-group row">
                        <div class="col-5">
                          <b-form-tags
                            id="tags-with-dropdown"
                            v-model="relation"
                            no-outer-focus
                          >
                            <template v-slot="{ tags, disabled, removeTag }">
                              <ul
                                v-if="tags.length > 0"
                                class="list-inline d-inline-block mb-2"
                              >
                                <li
                                  v-for="(tag, index) in tags"
                                  :key="index"
                                  class="list-inline-item mb-2 align-center"
                                  float="center"
                                >
                                  <b-form-tag
                                    @remove="removeTag(tag)"
                                    :title="tag"
                                    :disabled="disabled"
                                    variant="primary"
                                  >
                                    <div
                                      class="team justify-content-centerml-5"
                                    >
                                      <a
                                        href="javascript: void(0);"
                                        class="team-member d-inline-block"
                                      >
                                        <img
                                          :src="
                                            url_image + JSON.parse(tag).image
                                          "
                                          class="rounded-circle avatar-xs m-1"
                                          alt
                                        />
                                      </a>
                                    </div>
                                    {{ JSON.parse(tag).name }}
                                  </b-form-tag>
                                </li>
                              </ul>

                              <b-dropdown
                                v-if="relation.length !== 1"
                                size="sm"
                                variant="outline-secondary"
                                block
                                menu-class="w-100"
                              >
                                <template #button-content>
                                  {{
                                    $t("wizard.form.button.relation_profile")
                                  }}
                                </template>
                                <b-dropdown-form
                                  @submit.stop.prevent="() => {}"
                                >
                                  <b-form-group
                                    label-for="tag-search-input"
                                    label-cols-md="auto"
                                    class="mb-0"
                                    label-size="sm"
                                    :description="searchDesc"
                                    :disabled="disabled"
                                  >
                                    <b-form-input
                                      v-on:keyup="
                                        searchTarget != ''
                                          ? (show = true)
                                          : (show = false)
                                      "
                                      v-model="searchTarget"
                                      id="tag-search-input"
                                      type="search"
                                      size="sm"
                                      autocomplete="off"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-dropdown-form>
                                <b-dropdown-divider> </b-dropdown-divider>

                                <b-dropdown-item-button
                                  v-show="show"
                                  v-for="(option, index) in availableOptions"
                                  :key="index"
                                  @click="onOptionClick(option)"
                                >
                                  {{ option.name }}
                                </b-dropdown-item-button>
                                <b-dropdown-text
                                  v-if="availableOptions.length === 0"
                                >
                                  {{ $t("wizard.form.validation.not_match2") }}
                                </b-dropdown-text>
                              </b-dropdown>
                            </template>
                          </b-form-tags>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%"></td>
                    <td>
                      <div>
                        <button
                          class="
                            xbadge
                            btn btn-success
                            mr-1
                            mb-1
                            px-2
                            text-white
                          "
                          :disabled="relation.length !== 1"
                          @click="AddTargetCarrer"
                        >
                          {{ $t("education.simpan") }}
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12 text-center" v-if="dnfp && dnf && !userList">
              <p class="text-secondary p-5">
                {{ $t("overview.table.all.dnf") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import EducationService from "@/helpers/education.service";
import PreferenceService from "@/helpers/preference.service.js";
import PhoneService from "@/helpers/phone.service.js";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Education Search",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      backUrl: "/education-search",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("education.career-search"),
          href: "/career-search",
        },
        {
          text: this.$t("education.career-detail"),
          active: true,
        },
      ],

      title: this.$t("education.career-detail"),
      id: this.$route.params.id,
      url_image:
        process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      loadingGrup: false,
      loading: false,
      loadinglist: false,
      search: false,
      searchKey: "",
      searchTarget: "",
      result: "",
      relation: [],
      options: [],
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,
      pref: "",
      api_host: "",
      x_rapidapi_host: "",
      x_rapidapi_key: "",
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },

    criteria() {
      return this.searchTarget.trim().toLowerCase();
    },

    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.relation.length; i++) {
          element.push(JSON.parse(this.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },
  methods: {
    getPreferences() {
      let id = 2;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          this.pref = response.data.data;
          this.api_host = response.data.data.api_host;
          this.x_rapidapi_host = response.data.data.api_header_host;
          this.x_rapidapi_key = response.data.data.api_header_key;
          this.getNama();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getNama() {
      this.loading = true;
      let headers = {
        "content-type": "application/json",
        "x-rapidapi-host": this.x_rapidapi_host,
        "x-rapidapi-key": this.x_rapidapi_key,
      };
      let data = {
        profile_id: this.id,
        profile_type: "personal",
        contact_info: true,
        recommendations: false,
        related_profiles: true,
      };
      console.log(headers, data);
      return axios
        .post(this.api_host, data, { headers: headers })
        .then((response) => {
          this.result = response.data;
          console.log(response.data);
          this.dnf = false;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.search = false;
          this.loading = false;
          this.dnf = true;
        });
    },

    listProfile() {
      TargetService.getTargetBy()
        .then((response) => {
          response.data.data.forEach((val) => {
            const opt = {
              name: val.title,
              id: val.id_target,
              image: val.image_project,
            };
            this.options.push(opt);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onOptionClick(option) {
      // console.log(option)
      // this.relation.id = option.id;
      // this.relation.name = option.name;
      // this.relation.image = option.image;
      this.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },

    AddTargetCarrer() {
      let data = {
        id_target: JSON.parse(this.relation).id,
        profile_id: this.result.profile_id,
        first_name: this.result.first_name,
        last_name: this.result.last_name,
        profile_picture: this.result.profile_picture,
        profile_positions: JSON.stringify(this.result.position_groups),
        skills: JSON.stringify(this.result.skills),
        certifications: JSON.stringify(this.result.certifications),
        publications: JSON.stringify(this.result.publications),
      };
      console.log(data);
      EducationService.SaveCareer(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push({
            name: "project-overview",
            params: { id: JSON.parse(this.relation).id },
          });
          // this.$router.push('/career-search');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toFixed(value) {
      return value.toFixed(0);
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    formatMonth(value) {
      if (value == 1) {
        var bulan = "Jan";
      } else if (value == 2) {
        var bulan = "Feb";
      } else if (value == 3) {
        var bulan = "Mar";
      } else if (value == 4) {
        var bulan = "Apr";
      } else if (value == 5) {
        var bulan = "Mei";
      } else if (value == 6) {
        var bulan = "Jun";
      } else if (value == 7) {
        var bulan = "Jul";
      } else if (value == 8) {
        var bulan = "Agu";
      } else if (value == 9) {
        var bulan = "Sep";
      } else if (value == 10) {
        var bulan = "Okt";
      } else if (value == 11) {
        var bulan = "Nov";
      } else if (value == 12) {
        var bulan = "Des";
      }
      return bulan;
    },
  },
  beforeMount() {
    this.listProfile();
    this.getPreferences();
  },
  mounted() {
    // this.getNama();
    this.availableOptions;
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>